import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
    Typography,
    Button,
    Row,
    Col,
    Card,
    Table,
    Tag,
    theme,
    Space,
    Badge,
    Flex,
    Avatar,
    Progress,
    message,
} from "antd";
import {
    QrcodeOutlined,
    ShoppingOutlined,
    PlusOutlined,
    TrophyOutlined,
    FireOutlined,
    UserOutlined,
    GiftFilled,
    RocketOutlined,
    CrownFilled,
    FireFilled,
    TrophyFilled,
    StarFilled,
    AimOutlined,
    MessageTwoTone,
} from "@ant-design/icons";
import { getBackendUrl } from '../../utils/env';
import axios from "axios";


const { Title, Paragraph, Text } = Typography;

const makeStyles = (t) => `
/* ── Ranking ── */
  .db-ranking-card {
    background: ${t.colorBgContainer};
    border: 1px solid ${t.colorBorderSecondary};
    border-radius: 20px;
    overflow: hidden;
  }
    .db-section-title {
    font-family: 'Syne', sans-serif;
    font-weight: 700;
    font-size: 13px;
    letter-spacing: 3px;
    text-transform: uppercase;
    color: ${t.colorTextTertiary};
    margin-bottom: 20px;
  }
      .db-section {
    padding: clamp(32px, 6vw, 48px) clamp(20px, 5vw, 48px) 0;
  }
  .db-ranking-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 18px 22px;
    border-bottom: 1px solid ${t.colorBorderSecondary};
  }
  .db-ranking-head-title {
    font-family: 'Syne', sans-serif;
    font-weight: 700;
    font-size: 15px;
    color: ${t.colorText};
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .db-ranking-see-all {
    font-size: 12px;
    font-weight: 600;
    color: #ffe000;
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;
    letter-spacing: 0.5px;
  }
  .db-ranking-see-all:hover { opacity: 0.75; }

  .db-rank-row {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 14px 22px;
    border-bottom: 1px solid ${t.colorBorderSecondary};
    animation: fadeUp 0.3s ease both;
    transition: background 0.15s;
  }
  .db-rank-row:last-child { border-bottom: none; }
  .db-rank-row:hover { background: ${t.colorFillAlter}; }

  .db-rank-medal {
    font-size: 18px;
    width: 28px;
    text-align: center;
    flex-shrink: 0;
  }
  .db-rank-name {
    flex: 1;
    font-size: 14px;
    font-weight: 500;
    color: ${t.colorText};
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .db-rank-pts {
    font-family: 'Syne', sans-serif;
    font-size: 15px;
    font-weight: 700;
    color: #ffe000;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    gap: 4px;
  }
    .db-ranking-motivation {
    margin-top: 12px;
    padding: 14px 16px;
    border-radius: 14px;

    background: linear-gradient(
        135deg,
        rgba(255, 184, 0, 0.09),
        rgba(255, 184, 0, 0.03)
    );

    border: 1px solid rgba(255, 184, 0, 0.20);

    text-align: center;

    animation: rankingMotivationIn 0.35s ease;
}

.db-ranking-motivation-main {
    font-size: 13px;
    line-height: 1.5;
}

.db-ranking-motivation-main strong {
    color: #FFB800;
    font-size: 14px;
    font-weight: 700;
}

.db-ranking-motivation-sub {
    margin-top: 3px;

    color: var(--ant-color-text-secondary);
    font-size: 12px;
}

@keyframes rankingMotivationIn {
    from {
        opacity: 0;
        transform: translateY(4px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

  /* ── Skeleton ── */
  @keyframes shimmer {
    0%   { background-position: -600px 0; }
    100% { background-position: 600px 0; }
  }
  .skeleton {
    border-radius: 6px;
    background: linear-gradient(
      90deg,
      ${t.colorFillAlter} 25%,
      ${t.colorFillSecondary} 50%,
      ${t.colorFillAlter} 75%
    );
    background-size: 600px;
    animation: shimmer 1.4s infinite linear;
  }

  /* ── Animations ── */
  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(16px); }
    to   { opacity: 1; transform: translateY(0); }
  }
  .db-hero { animation: fadeUp 0.5s ease both; }
`;

const MEDALS = ["🥇", "🥈", "🥉"];


export default function Dashboard() {


    const acciones = [
        {
            icon: <QrcodeOutlined />,
            title: "Escanear QR",
            desc: "Participa en actividades",
            onClick: () => navigate("/scan"),
        },
        {
            icon: <ShoppingOutlined />,
            title: "Tienda",
            desc: "Canjea tus bravos",
            onClick: () => navigate("/store"),
        },
        {
            icon: <TrophyOutlined />,
            title: "Ranking",
            desc: "Revisa tu posición",
            onClick: () => navigate("/ranking"),
        },
        {
            icon: <UserOutlined />,
            title: "Perfil",
            desc: "Tu información personal",
            onClick: () => navigate("/perfil"),
        },
        {
            icon: <PlusOutlined />,
            title: "Comentarios",
            desc: "Envía sugerencias",
            onClick: () => navigate("/feedback"),
        },
        {
            icon: <RocketOutlined />,
            title: "Eventos",
            desc: "Próximas actividades",
            onClick: () => navigate("/events"),
        },
        {
            icon: <AimOutlined />,
            title: "Juegos (Beta)",
            desc: "Desafíos y minijuegos",
            onClick: () => navigate("/games"),
        },
        {
            icon: < MessageTwoTone />,
            title: "Chatea con nuestra IA (Beta)",
            desc: "Resuelve tus dudas",
            onClick: () => message("En desarrollo"),
        }

    ];

    const [ranking, setRanking] = useState([]);
    const [miRanking, setMiRanking] = useState({
        usuario: null,
        anterior: null,
    });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const navigate = useNavigate();
    const { token } = theme.useToken();
    const [puntosActuales, setPuntosActuales] = useState(0);
    const userId = parseInt(localStorage.getItem("user_id"), 10) || null;

    

    useEffect(() => {
        const fetchRanking = async () => {
            setLoading(true);

            try {
                const tokenAuth = localStorage.getItem("token");

                const res = await axios.get(
                    `${getBackendUrl()}api/ranking.php`,
                    {
                        headers: {
                            Authorization: `Bearer ${tokenAuth}`,
                        },
                    }
                );

                if (res.data.success) {
                    const rankingCompleto = res.data.ranking;

                    // Agregar posición a todos
                    const rankingConPosicion = rankingCompleto.map(
                        (u, index) => ({
                            ...u,
                            position: index + 1,
                        })
                    );

                    // ==============================
                    // MI POSICIÓN
                    // ==============================

                    const usuarioActual = rankingConPosicion.find(
                        u => String(u.id) === String(userId)
                    );

                    if (usuarioActual) {
                        setPuntosActuales(Number(usuarioActual.points) || 0);
                    }


                    const usuarioAnterior = usuarioActual
                        ? rankingConPosicion.find(
                            u => u.position === usuarioActual.position - 1
                        )
                        : null;


                    // ==============================
                    // TOP 3
                    // ==============================

                    const top3 = rankingConPosicion.slice(0, 3);

                    // ==============================
                    // RANKING QUE SE MUESTRA
                    // ==============================

                    const rankingMostrar =
                        usuarioActual &&
                            !top3.some(
                                u => String(u.id) === String(userId)
                            )
                            ? [...top3, usuarioActual]
                            : top3;

                    setRanking(rankingMostrar);

                    // Guardamos la información completa
                    // para la motivación
                    setMiRanking({
                        usuario: usuarioActual,
                        anterior: usuarioAnterior,
                    });

                    setError(null);

                } else {
                    setError(
                        res.data.message ||
                        "No se pudo cargar el ranking"
                    );
                }
            } catch (err) {
                setError(
                    err.message ||
                    "Error al cargar ranking"
                );
            } finally {
                setLoading(false);
            }
        };

        fetchRanking();
    }, [userId]);

    const bravoColor = "#ffe000";


    const getPositionTag = (index) => {
        const style = { fontWeight: "bold" };
        switch (index) {
            case 0: return <Tag color="gold" style={style}>🥇 {index + 1}</Tag>;
            case 1: return <Tag color="silver" style={style}>🥈 {index + 1}</Tag>;
            case 2: return <Tag color="volcano" style={style}>🥉 {index + 1}</Tag>;
            default: return <Tag style={style}>{index + 1}</Tag>;
        }
    };

    const getPointsTag = (points, index) => {
        const style = { fontWeight: "bold" };
        if (index < 5) return <span style={style}><FireOutlined style={{ color: "red", marginRight: 4 }} />{points}</span>;
        return <span style={style}>{points}</span>;
    };

    const rowClassName = (record) => record.id.toString() === userId ? "current-user-row" : "";

    const columns = [
        { title: "Posición", render: (_, __, index) => getPositionTag(index), align: "center" },
        { title: "Usuario", dataIndex: "name", render: (text) => <span style={{ fontWeight: 500, color: token.colorText }}>{text}</span> },
        { title: "Bravos", dataIndex: "points", render: (_, record, index) => getPointsTag(record.points, index), align: "right" },
    ];


    // ============================================================
    // NIVEL DEL USUARIO
    // ============================================================

    const niveles = [
        { nombre: "INICIADO", minimo: 0, icono: "🌱", siguiente: 500 },
        { nombre: "ACTIVO", minimo: 500, icono: "🔥", siguiente: 1000 },
        { nombre: "CONSTANTE", minimo: 1000, icono: "⚡", siguiente: 1500 },
        { nombre: "LÍDER", minimo: 1500, icono: "👑", siguiente: 2500 },
        { nombre: "GUÍA", minimo: 2500, icono: "🧭", siguiente: 3500 },
        { nombre: "INSPIRADOR", minimo: 3500, icono: "✨", siguiente: 5000 },
        { nombre: "CAMPEÓN", minimo: 5000, icono: "🏆", siguiente: 6500 },
        { nombre: "MAESTRO", minimo: 6500, icono: "🎓", siguiente: 8000 },
        { nombre: "ÉLITE", minimo: 8000, icono: "💫", siguiente: 10000 },
        { nombre: "LEYENDA", minimo: 10000, icono: "💎", siguiente: null },
    ];

    const nivelActual =
        [...niveles]
            .reverse()
            .find((nivel) => puntosActuales >= nivel.minimo) || niveles[0];

    const nivelAnterior = niveles.findIndex(
        (nivel) => nivel.nombre === nivelActual.nombre
    );

    const siguienteNivel =
        nivelAnterior < niveles.length - 1
            ? niveles[nivelAnterior + 1]
            : null;

    const progresoNivel = siguienteNivel
        ? Math.min(
            100,
            Math.round(
                ((puntosActuales - nivelActual.minimo) /
                    (siguienteNivel.minimo - nivelActual.minimo)) *
                100
            )
        )
        : 100;

    const puntosParaSiguiente = siguienteNivel
        ? Math.max(0, siguienteNivel.minimo - puntosActuales)
        : 0;

    const css = makeStyles(token);

    return (
        <div
            style={{
                width: "100%",
                minHeight: "100vh",
                padding: "32px 24px 60px",
            }}
        >
            <style>{css}</style>
            {/* =========================================================
            HERO
        ========================================================== */}

            <section
                style={{
                    position: "relative",
                    overflow: "hidden",
                    borderRadius: 28,
                    padding: "clamp(28px, 5vw, 48px)",
                    marginBottom: 32,
                    background: `linear-gradient(
                    135deg,
                    ${bravoColor}18,
                    ${bravoColor}05
                )`,
                    border: `1px solid ${bravoColor}30`,
                }}
            >

                {/* Decoraciones */}

                <div
                    style={{
                        position: "absolute",
                        right: -20,
                        top: -30,
                        fontSize: 150,
                        opacity: 0.06,
                        transform: "rotate(15deg)",
                        pointerEvents: "none",
                    }}
                >
                    🔥
                </div>

                <div
                    style={{
                        position: "absolute",
                        right: 100,
                        bottom: -40,
                        fontSize: 120,
                        opacity: 0.04,
                        pointerEvents: "none",
                    }}
                >
                    🚀
                </div>

                <Space
                    orientation="vertical"
                    size={18}
                    style={{
                        position: "relative",
                        zIndex: 1,
                        width: "100%",
                    }}
                >

                    <Tag
                        color="gold"
                        style={{
                            borderRadius: 999,
                            padding: "6px 14px",
                            fontWeight: 800,
                            border: "none",
                        }}
                    >
                        {nivelActual.icono} NIVEL {nivelActual.nombre}
                    </Tag>

                    <Title
                        level={1}
                        style={{
                            margin: 0,
                            color: token.colorText,
                            fontSize: "clamp(32px, 6vw, 48px)",
                            fontWeight: 900,
                        }}
                    >
                        ¡Qué bueno verte, {localStorage.getItem("name") || "hermano"}! 👋
                    </Title>

                    <Paragraph
                        style={{
                            margin: 0,
                            maxWidth: 650,
                            fontSize: "clamp(16px, 2vw, 19px)",
                            color: token.colorTextSecondary,
                        }}
                    >
                        Tu participación se convierte en{" "}
                        <strong
                            style={{
                                color: bravoColor,
                            }}
                        >
                            Bravos
                        </strong>
                        . ¿Listo para sumar más?
                    </Paragraph>

                    {/* PUNTOS */}

                    <div
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            alignItems: "center",
                            gap: 20,
                            marginTop: 8,
                        }}
                    >

                        <div
                            style={{
                                padding: "16px 22px",
                                borderRadius: 18,
                                background: token.colorBgContainer,
                                border: `1px solid ${token.colorBorderSecondary}`,
                            }}
                        >
                            <Text
                                type="secondary"
                                style={{
                                    display: "block",
                                    fontSize: 12,
                                }}
                            >
                                TUS BRAVOS
                            </Text>

                            <div
                                style={{
                                    fontSize: "clamp(32px, 6vw, 44px)",
                                    fontWeight: 900,
                                    lineHeight: 1.1,
                                    color: bravoColor,
                                }}
                            >
                                🔥 {puntosActuales.toLocaleString()}
                            </div>
                        </div>

                        <Button
                            type="primary"
                            size="large"
                            icon={<QrcodeOutlined />}
                            onClick={() => navigate("/scan")}
                            style={{
                                background: bravoColor,
                                borderColor: bravoColor,
                                color: "#000",
                                fontWeight: 900,
                                borderRadius: 16,
                                height: 56,
                                padding: "0 32px",
                                fontSize: 17,
                                boxShadow: `0 8px 20px ${bravoColor}45`,
                            }}
                        >
                            ESCANEAR AHORA
                        </Button>

                    </div>

                </Space>
            </section>


            {/* =========================================================
            PROGRESO
        ========================================================== */}

            <div
                className="db-section"
                style={{
                    marginBottom: 32,
                }}
            >

                <div
                    className="db-section-title"
                    style={{
                        marginBottom: 14,
                    }}
                >
                    Tu progreso
                </div>

                <Card
                    style={{
                        borderRadius: 24,
                        border: `1px solid ${token.colorBorderSecondary}`,
                        overflow: "hidden",
                    }}
                    styles={{
                        body: {
                            padding: "24px",
                        },
                    }}
                >

                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: 16,
                            marginBottom: 16,
                            flexWrap: "wrap",
                        }}
                    >

                        <div>
                            <div
                                style={{
                                    fontSize: 24,
                                    fontWeight: 900,
                                }}
                            >
                                {nivelActual.icono} {nivelActual.nombre}
                            </div>

                            <Text type="secondary">
                                {siguienteNivel
                                    ? `Siguiente nivel: ${siguienteNivel.icono} ${siguienteNivel.nombre}`
                                    : "Has alcanzado el nivel máximo"}
                            </Text>
                        </div>

                        <div
                            style={{
                                textAlign: "right",
                            }}
                        >
                            <div
                                style={{
                                    fontSize: 22,
                                    fontWeight: 900,
                                    color: bravoColor,
                                }}
                            >
                                {progresoNivel}%
                            </div>

                            <Text type="secondary">
                                progreso
                            </Text>
                        </div>

                    </div>


                    <Progress
                        percent={progresoNivel}
                        showInfo={false}
                        strokeColor={bravoColor}
                        trailColor={token.colorFillSecondary}
                        size={{
                            height: 12,
                        }}
                    />


                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            gap: 12,
                            marginTop: 12,
                            flexWrap: "wrap",
                        }}
                    >

                        <Text type="secondary">
                            🔥 {puntosActuales.toLocaleString()} B
                        </Text>

                        {siguienteNivel ? (
                            <Text
                                style={{
                                    fontWeight: 700,
                                }}
                            >
                                Te faltan{" "}
                                <span
                                    style={{
                                        color: bravoColor,
                                    }}
                                >
                                    {puntosParaSiguiente.toLocaleString()} B
                                </span>{" "}
                                para subir 👀
                            </Text>
                        ) : (
                            <Text
                                style={{
                                    color: bravoColor,
                                    fontWeight: 800,
                                }}
                            >
                                💎 NIVEL MÁXIMO
                            </Text>
                        )}

                    </div>

                </Card>
            </div>


            {/* =========================================================
            RANKING
        ========================================================== */}

            <div className="db-section">

                <div className="db-section-title">
                    Líderes
                </div>

                <div className="db-ranking-card">

                    <div className="db-ranking-head">

                        <span className="db-ranking-head-title">
                            <CrownFilled
                                style={{
                                    color: bravoColor,
                                }}
                            />

                            Top 3 · Bravos
                        </span>

                        <button
                            className="db-ranking-see-all"
                            onClick={() => navigate("/ranking")}
                        >
                            Ver tabla completa →
                        </button>

                    </div>


                    {loading ? (

                        Array.from({ length: 3 }).map((_, i) => (
                            <div
                                key={i}
                                className="db-rank-row"
                            >
                                <div
                                    className="skeleton"
                                    style={{
                                        width: 28,
                                        height: 20,
                                        borderRadius: 4,
                                    }}
                                />

                                <div
                                    className="skeleton"
                                    style={{
                                        flex: 1,
                                        height: 14,
                                    }}
                                />

                                <div
                                    className="skeleton"
                                    style={{
                                        width: 48,
                                        height: 18,
                                    }}
                                />
                            </div>
                        ))

                    ) : (

                        ranking.map((userRank, i) => (

                            <React.Fragment key={userRank.id}>

                                {i === 3 && (
                                    <div
                                        style={{
                                            textAlign: "center",
                                            color: token.colorTextSecondary,
                                            fontSize: 12,
                                            padding: "8px 0",
                                            letterSpacing: 2,
                                        }}
                                    >
                                        · · ·
                                    </div>
                                )}

                                <div
                                    className="db-rank-row"
                                    style={{
                                        animationDelay: `${i * 0.07}s`,
                                        background:
                                            String(userRank.id) ===
                                                String(userId)
                                                ? `${bravoColor}10`
                                                : undefined,
                                    }}
                                >

                                    <span className="db-rank-medal">
                                        {userRank.position <= 3
                                            ? MEDALS[userRank.position - 1]
                                            : `#${userRank.position}`}
                                    </span>


                                    <Avatar
                                        size={32}
                                        src={
                                            userRank.profile_picture
                                                ? `${getBackendUrl()}${userRank.profile_picture}`
                                                : null
                                        }
                                        icon={<UserOutlined />}
                                        style={{
                                            flexShrink: 0,
                                            border: `2px solid ${token.colorBorderSecondary}`,
                                        }}
                                    />


                                    <span className="db-rank-name">

                                        {userRank.name}

                                        {String(userRank.id) ===
                                            String(userId) && (
                                                <span
                                                    style={{
                                                        color: bravoColor,
                                                        marginLeft: 6,
                                                        fontWeight: 700,
                                                    }}
                                                >
                                                    (Tú)
                                                </span>
                                            )}

                                    </span>


                                    <span className="db-rank-pts">

                                        {userRank.position <= 3 && (
                                            <FireFilled
                                                style={{
                                                    fontSize: 12,
                                                    color: "#FF6B35",
                                                }}
                                            />
                                        )}

                                        {userRank.points.toLocaleString()} B

                                    </span>

                                </div>

                            </React.Fragment>

                        ))

                    )}


                    {/* =================================================
                    MOTIVACIÓN DEL RANKING
                ================================================== */}
                    {miRanking?.usuario && (() => {
                        const yo = miRanking.usuario;
                        const anterior = miRanking.anterior;

                        // 🥇 Primer lugar
                        if (yo.position === 1) {
                            return (
                                <div className="db-ranking-motivation">
                                    👑 <strong>¡Estás en el primer lugar!</strong>
                                    <br />
                                    <Text type="secondary">
                                        Mantén el ritmo y defiende tu posición 🔥
                                    </Text>
                                </div>
                            );
                        }

                        if (!anterior) return null;

                        const diferencia = anterior.points - yo.points;

                        return (
                            <div className="db-ranking-motivation">
                                <div className="db-ranking-motivation-main">
                                    🔥 Estás a{" "}
                                    <strong>
                                        {diferencia.toLocaleString()} B
                                    </strong>{" "}
                                    del #{anterior.position}
                                </div>

                                <div className="db-ranking-motivation-sub">
                                    ¡Un poco más y subes de posición! 🚀
                                </div>
                            </div>
                        );
                    })()}

                </div>
            </div>


            {/* =========================================================
            ACCIONES RÁPIDAS
        ========================================================== */}

            <Title
                level={4}
                style={{
                    marginBottom: 24,
                    paddingLeft: 8,
                    marginTop: 36,
                }}
            >
                Acceso Rápido
            </Title>


            <Row gutter={[20, 20]}>

                {acciones.map((item, index) => (

                    <Col
                        xs={12}
                        sm={12}
                        md={8}
                        key={index}
                    >

                        <Card
                            hoverable
                            onClick={item.onClick}
                            style={{
                                borderRadius: 24,
                                border: `1px solid ${token.colorBorderSecondary}`,
                                textAlign: "center",
                                background: token.colorBgContainer,
                                transition:
                                    "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
                            }}
                            styles={{
                                body: {
                                    padding: "32px 16px",
                                },
                            }}
                        >

                            <Avatar
                                size={64}
                                icon={item.icon}
                                style={{
                                    backgroundColor: `${bravoColor}15`,
                                    color: bravoColor,
                                    marginBottom: 16,
                                    fontSize: 28,
                                    border: `1px solid ${bravoColor}30`,
                                }}
                            />

                            <Title
                                level={5}
                                style={{
                                    margin: 0,
                                }}
                            >
                                {item.title}
                            </Title>

                            <Text
                                type="secondary"
                                style={{
                                    fontSize: 12,
                                }}
                            >
                                {item.desc}
                            </Text>

                        </Card>

                    </Col>

                ))}

            </Row>

        </div>
    );
}
